// extracted by mini-css-extract-plugin
module.exports = {"pie-chart":"_7a3fb80146--pie-chart--ftJyD"};